import { AdminRolesEnum } from 'shared/enums/user-roles-enum'
import useUser from './use-user'

export const useShowChangePasswordPage = () => {
  const {
    checkImpersonatorAdminRoles,
    isWorkspaceOwner,
    isSupportImpersonation,
    isSubAccountImpersonation,
  } = useUser()

  return {
    showChangePasswordPage: isSubAccountImpersonation
      ? false
      : isSupportImpersonation
      ? checkImpersonatorAdminRoles([AdminRolesEnum.admin, AdminRolesEnum.superAdmin])
      : isWorkspaceOwner,
  }
}
